import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface PaginationParameters {
	page: number;
	page_size: number;
}

@Injectable()
export abstract class PaginationService {
	private _paginatorRefresh = new EventEmitter();
	private _pagedSource = new Subject<PagedEvent>();

	private _current_page: number = 0;
	private _page_size: number = 10;
	private _total_pages = 0;
	private _dataset_size = 0;

	protected constructor() {}

	public get paged$() {
		return this._pagedSource.asObservable();
	}
	public get paginatorRefresh$() {
		return this._paginatorRefresh;
	}

	public init() {}

	public get currentPage() {
		return this._current_page;
	}
	public set page(value: number) {
		this._current_page = value || 0;
	}
	public get pageSize() {
		return this._page_size;
	}
	public set pageSize(value: number) {
		this._page_size = value || 0;
	}
	public get totalPages() {
		return this._total_pages;
	}
	public get dataSize() {
		return this._dataset_size;
	}
	public get pagination(): PaginationParameters {
		return {
			page: this._current_page,
			page_size: this._page_size,
		};
	}

	public paged(event: PagedEvent, ignorePaginator?: any) {
		if (typeof event.page === 'undefined') {
			event.page = this._current_page;
		}
		if (!event.size) {
			event.size = this._page_size;
		}
		this._current_page = event.page;
		this._page_size = event.size;
		this._pagedSource.next(event);
		if (!ignorePaginator) {
			this.paginatorRefresh$.emit();
		}
		this.onStateChanged();
	}

	public config(settings: PaginationSettings) {
		this._current_page = settings.currentPage || 0;
		this._page_size = settings.pageSize || this._page_size;
		this._total_pages = settings.totalPages;
		this._dataset_size = settings.datasetSize;
		this.initFlock();
	}

	public flush() {
		this._current_page = 0;
		this._page_size = 10;
		this._total_pages = 0;
		this._dataset_size = 0;
	}

	protected onStateChanged(): void {}

	private initFlock() {
		this.paged({ page: this._current_page, size: this._page_size }, true);
	}
}

export interface PaginationSettings {
	currentPage: number;
	totalPages: number;
	datasetSize: number;
	pageSize: number;
}

export class PagedEvent {
	page?: number;
	size?: number;
}
